import type { SelectHTMLAttributes } from 'react';
import { cx } from '../lib/cx';
import { Field, borderClass, controlClass } from './Field';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  id: string;
  label?: string;
  hint?: string;
  error?: string | undefined;
  options: readonly SelectOption[];
  /** Prazan izbor na vrhu popisa; bez njega izbornik izgleda kao da je već odlučeno. */
  placeholder?: string;
}

export function Select({
  id,
  label,
  hint,
  error,
  options,
  placeholder,
  className,
  required,
  ...rest
}: SelectProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      {/*
        `appearance-none` gasi izvornu strelicu preglednika, pa je moramo nacrtati
        sami — inače polje izgleda kao obično tekstualno i nitko ne zna da se klikne.
        `pointer-events-none` da klik na strelicu i dalje otvara popis.
      */}
      <span className="relative block">
        <select
          id={id}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          className={cx(controlClass, borderClass(!!error), 'appearance-none pr-10', className)}
          {...rest}
        >
          {placeholder !== undefined && <option value="">{placeholder}</option>}
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          width={18}
          height={18}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 text-ink-muted"
        >
          <path d="m6 9.5 6 6 6-6" />
        </svg>
      </span>
    </Field>
  );
}
